module.exports = __webpack_public_path__ + "img/DSC_0007.e9d3f44f.jpg";